'use client';
import { useTranslations } from 'next-intl';
import type React from 'react';

import { cn } from '@cineamo/ui/src/helpers/cn';

import type { SeatMapViewMode } from '@cineamo/composables/src/ticket-booking/seat-map-view-mode';

const MODES: SeatMapViewMode[] = ['2D', '3D'];

const SeatMapViewToggle: React.FC<{
    mode: SeatMapViewMode;
    onChange: (mode: SeatMapViewMode) => void;
    className?: string;
}> = ({ mode, onChange, className }) => {
    const t = useTranslations('tickets');
    return (
        <div className={cn('flex items-center gap-6', className)}>
            <span
                aria-hidden="true"
                className="rounded-4 bg-black/50 px-8 py-4 text-body-bold-14 text-white backdrop-blur-[6px]">
                {t('seat-map-view-caption')}
            </span>
            <div
                role="radiogroup"
                aria-label={t('seat-map-view-label')}
                className="flex items-center rounded-[6px] bg-black/50 p-2 backdrop-blur-[6px]">
                {MODES.map((m) => (
                    <button
                        key={m}
                        type="button"
                        role="radio"
                        aria-checked={mode === m}
                        onClick={() => {
                            if (m !== mode) onChange(m);
                        }}
                        className={cn(
                            // Dark glass like the other map controls, so it stays readable over light and dark rooms.
                            'rounded-4 px-12 py-4 text-body-bold-12 outline-none focus-visible:ring-2 focus-visible:ring-[var(--primary-color)]',
                            mode === m
                                ? 'bg-white text-darkBlue shadow-[0_3px_4px_rgba(0,0,0,0.12),0_3px_0.5px_rgba(0,0,0,0.04)]'
                                : 'text-white'
                        )}>
                        {t(m === '2D' ? 'seat-map-view-2d' : 'seat-map-view-3d')}
                    </button>
                ))}
            </div>
        </div>
    );
};

export default SeatMapViewToggle;
